import React, { Fragment, useEffect, useState } from 'react';
import numeral from 'numeral';
import BiHelp from './BiHelp';

const BiTextBox = ({
    name,
    value,
    onChange,
    onKeyDown,
    style,
    width,
    disabled,
    numeric,
    format,
    placeholder,
    align,
    help,
    helpKey,
    helpMainKey,
    pattern,
    inputmode,
    readOnly,
    maxlength,

}) => {
    let dod = {
        width: width == null ? "" : (width + "px").replace("%px","%")
    }

    let frm = "0.[00]";
    if (format != null) {
        frm = format;
    }


    const [text, setText] = useState("");

    useEffect(() => {
        if (value != null) {

            if (numeric) {
                var num = numeral(value);
                setText(num.format(frm));
            }
            else {
                setText(value);
            }
        } else {
            setText("");
        }

    }, [value]);

    const onBlured = (e) => {
        if (onChange != null) {
            let val = e.target.value;

            if (numeric == true) {
                if (val == "" || val == null) {
                    onChange({ target: { name: name, value: null } });
                } else {
                    let num = numeral(val.replace(",", ".").replace(",", ".").replace(",", ".")); //nemsto replace all
                    val = num.format(frm);
                    let prav = numeral(val);
                    onChange({ target: { name: name, value: prav.value() } });
                }
            } else {
                onChange({ target: { name: name, value: val } });
            }
        }

       
    }

    const onChanged = (e) => {
        setText(e.target.value);

        if (onKeyDown != null) {

            onKeyDown(e);

        }
    }

    return (

        <div className="biHelpCont" style={{ ...style, ...dod }}>
            <input
                type="text"
                className="form-control form-control-sm biControlInline biInput"
                name={name}
                style={align != null ? { textAlign: align } : {}}
                disabled={disabled ? "disabled" : ""}
                placeholder={placeholder}
                pattern={pattern}
                inputMode={inputmode}
                readOnly={readOnly}
                onBlur={(e) => onBlured(e)}
                onChange={(e) => onChanged(e)}
                value={text}
                maxLength={maxlength} />


            {(help == true) &&
                <BiHelp helpKey={helpKey ? helpKey : name} helpMainKey={helpMainKey ? helpMainKey : null}></BiHelp>
            }
        </div>
    );
}

export default BiTextBox;

